import axios from 'axios';

// 智能选择 API 基址：
// 1) 优先环境变量 REACT_APP_API_BASE_URL
// 2) Cloudflare Pages 生产：使用线上网关
// 3) 其他环境：走同源反代前缀
const isBrowser = typeof window !== 'undefined';
const isPages = isBrowser && /pages\.dev$/.test(window.location.hostname);
const fallbackBase = isPages ? 'https://api-do.whitelotus.work/springboot6hv37' : '/springboot6hv37';
const API_BASE = (process.env.REACT_APP_API_BASE_URL || fallbackBase).replace(/\/$/, '');

const instance = axios.create({ baseURL: API_BASE });

// 请求拦截器，附加 Token
instance.interceptors.request.use(
  (config) => {
    const token = localStorage.getItem('token');
    if (token) {
      config.headers.Token = token;
    } else {
      // 如果是需要身份验证的特定接口，但没有token，可以添加处理逻辑
      const requiresAuth = [
        '/favorite',  // 收藏相关接口
        '/orders',    // 订单相关接口
        '/user',      // 用户相关接口
        '/address',   // 地址相关接口
        '/payment'    // 支付相关接口
      ];
      
      // 检查当前请求是否需要身份验证
      const currentPath = config.url;
      const needsAuth = requiresAuth.some(path => currentPath.startsWith(path));
      
      if (needsAuth) {
        console.warn('访问需要身份验证的接口，但没有提供Token:', config.url);
      }
    }
    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);

// 响应拦截器 - 处理错误响应
instance.interceptors.response.use(
  response => {
    // 处理业务层面的错误码
    if (response.data && response.data.code !== undefined && response.data.code !== 0) {
      // 对于特定错误码的处理
      if (response.data.code === 401) {
        console.warn('认证失败，请重新登录');
        // 清除登录状态
        localStorage.removeItem('token');
        localStorage.removeItem('userData');
        localStorage.removeItem('user');
        
        // 可以通过事件通知应用程序需要重新登录
        window.dispatchEvent(new CustomEvent('auth:logout', { detail: '登录已过期' }));
      }
    }
    return response;
  },
  error => {
    // 网络错误或服务器错误处理
    if (error.message === 'Network Error' || (error.response && error.response.status === 404)) {
      console.warn('API请求失败:', error.config?.url, error.message);
    } else if (error.response) {
      switch (error.response.status) {
        case 401: // 未授权
          console.warn('认证失败，请重新登录');
          // 清除登录状态
          localStorage.removeItem('token');
          localStorage.removeItem('userData');
          localStorage.removeItem('user');
          
          // 可以通过事件通知应用程序需要重新登录
          window.dispatchEvent(new CustomEvent('auth:logout', { detail: '登录已过期' }));
          break;
          
        case 403: // 禁止访问
          console.warn('没有权限访问该资源');
          break;
          
        case 500: // 服务器错误
          console.error('服务器内部错误');
          break;
          
        default:
          console.error(`API错误 (${error.response.status}):`, error.response.data);
      }
    }
    return Promise.reject(error);
  }
);

export default instance;
